<template>
  <div class="content">
    <section class="ant-layout ant-layout-has-sider T4GEFebs3g8YOid0x1WP">
      <main class="ant-layout-content">
        <article class="XOBwycXUwfIkVzY1pEcS">
          <div class="jvyuEa1IMUYz6QYdQz8J" style="width: 100%">
            <div class="KynRwLTHLzs40xw0ZsgZ">
              <div class="NixFYMoANcTHWwQeLGLj">
                <div>
                  <h2 id="general-interval">条形图</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="简单柱形图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/interval/#bar-basic"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*kvZLSLxjnkIAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>简单柱形图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="简单条形图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/interval/#bar-basic-transposed"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*sxEATqf3uoEAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>简单条形图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="简单堆叠柱形图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/interval/#bar-basic-stacked"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*69WQTY8YrWgAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>简单堆叠柱形图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="简单分组柱形图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/interval/#bar-basic-grouped"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*kqGUT4wRYrsAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>简单分组柱形图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="可交互柱形图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/interval/#column-interactive"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*QdN3S6Zi4SUAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>可交互柱形图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="限制宽度的柱形图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/interval/#column-maxwidth"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*gw-YTIpoiZsAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>限制宽度的柱形图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="限制高度的柱形图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/interval/#column-min-height"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*W2SKQJ4i8xQAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>限制高度的柱形图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="对数柱形图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/interval/#column-log"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*Q6JdQpaVJ18AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>对数柱形图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="水平条形图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/interval/#bar"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*Kk02RLAcibAAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>水平条形图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="发散条形图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/interval/#bar-diverging"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*U11MRYv8BFUAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>发散条形图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="区间条形图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/interval/#bar-range"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*3Qm6RYLLBmUAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>区间条形图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="微妙级区间条形图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/interval/#bar-range-micro"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*g7gvQpvLqyIAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>微妙级区间条形图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="堆叠条形图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/interval/#bar-stacked"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*RqV4T4LZxaAAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>堆叠条形图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="堆叠水平条形图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/interval/#bar-stacked-horizontal"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*4Rr_Q4VSLkEAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>堆叠水平条形图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="归一化堆叠条形图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/interval/#bar-normalized-stacked"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*mCUsRYGa1owAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>归一化堆叠条形图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="分组条形图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/interval/#bar-dodged"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*JUTiSIaaUgEAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>分组条形图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="弹性条形图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/interval/#bar-flex"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*i_DyRJlDdVsAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>弹性条形图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="可变宽度条形图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/interval/#bar-var-width"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*ajNRTYbsuTgAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>可变宽度条形图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="马赛克图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/interval/#bar-marimekko"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*A_0eQI6xezsAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>马赛克图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="多轴条形图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/interval/#bar-dual-axes"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*K52LToQX-f4AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>多轴条形图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="固定宽度圆角条形图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/interval/#bar-fixed-cornered"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*opv8TY0CpbAAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>固定宽度圆角条形图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="圆角发散堆叠条形图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/interval/#bar-stacked-diverging-rounded"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*DVqDQaFExcAAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>圆角发散堆叠条形图</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="general-line">折线图</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="基础折线图">
                      <a class="X6AtY7FPSlY8cpJZ7YgY" hrefCustom="/examples/general/line/#base"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*o51NTbsP6EgAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>基础折线图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="曲线折线图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/line/#curved"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*hmVcTYfxR4gAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>曲线折线图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="阶梯折线图">
                      <a class="X6AtY7FPSlY8cpJZ7YgY" hrefCustom="/examples/general/line/#step"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*xvGZQY7sKhIAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>阶梯折线图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="普通折线图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/line/#line-basic"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*37vSSJwbSnwAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>普通折线图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="数据样本折线图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/line/#line-sample"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*68ViRIex2JEAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>数据样本折线图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="缺失折线图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/line/#line-connect-nulls"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*ASKfTqMVdkgAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>缺失折线图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="系列折线图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/line/#line-series"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*YBR5RIcf97UAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>系列折线图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="归一化折线图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/line/#line-normalized"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*WV2nRotltk4AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>归一化折线图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="聚合折线图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/line/#line-aggregated-label"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*Ti6mSZ8nHjYAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>聚合折线图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="变宽折线图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/line/#line-var-size"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*rjwSS4BTu3MAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>变宽折线图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="缺失变宽折线图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/line/#line-var-size-missing"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*X9vfS6o9FqMAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>缺失变宽折线图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="轨迹图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/line/#line-var-size-facet"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*lzESSbCPw2IAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>轨迹图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="多色折线图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/line/#line-variable-color"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*DKdDRrsfZywAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>多色折线图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="颜色编码折线图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/line/#line-gradient-encoding"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*t-GpRLtoipsAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>颜色编码折线图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="系列颜色编码折线图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/line/#line-series-var-color"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*B8sNSrK7-lsAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>系列颜色编码折线图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="阈值折线图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/line/#line-threshold"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*rHYnQ5-S6twAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>阈值折线图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="面积标注折线图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/line/#line-area-clip-path"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*GK8rQY5srTgAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>面积标注折线图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="斜率图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/line/#line-slope"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*RF2PTL6KNIQAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>斜率图</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="general-point">散点图</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="散点图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/point/#point-basic"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*-NYwTrAdwZ4AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>散点图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="一维散点图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/point/#point-one-dimension"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*GeijRY75QHgAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>一维散点图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="带子散点图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/point/#point-strip"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*0E-aSpAPPtwAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>带子散点图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="标签散点图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/point/#point-label"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*j_DBRKze77QAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>标签散点图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="多形状散点图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/point/#point-shape"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*SdKuRYFVCOIAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>多形状散点图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="渐变色散点图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/point/#point-sequential"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*20fLR5dh4SYAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>渐变色散点图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="扰动散点图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/point/#point-jitter"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*34m0QZPUjxMAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>扰动散点图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="堆叠散点图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/point/#point-stacked"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*extpT4E09xUAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>堆叠散点图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="气泡图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/point/#point-bubble"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*z8JFRLxrs_IAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>气泡图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="对数气泡图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/point/#point-log"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*mezjR7Iy-TYAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>对数气泡图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="聚合气泡图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/point/#point-aggregated"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*trHIR7xKaAcAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>聚合气泡图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="点图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/point/#point-dot"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*rhhlRLxuUYYAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>点图</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="general-area">面积图</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="简单面积图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/area/#area-basic"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*v1VOS7lUmckAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>简单面积图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="阶梯面积图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/area/#step-area"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*v20yQZopRV4AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>阶梯面积图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="面积图">
                      <a class="X6AtY7FPSlY8cpJZ7YgY" hrefCustom="/examples/general/area/#area"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*WkMRSKoc57UAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>面积图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="数据缺失面积图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/area/#missing-data-area"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*ox-rS7bQE48AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>数据缺失面积图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="负数面积图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/area/#area-with-negative"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*9cV1Rq1rr8EAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>负数面积图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="简单堆叠面积图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/area/#area-stacked-basic"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*VDBoSreSzqUAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>简单堆叠面积图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="百分比堆叠面积图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/area/#area-percentage"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*oDcJTangPsgAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>百分比堆叠面积图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="渐变色面积图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/area/#area-gradient"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*43MGTK5z-KgAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>渐变色面积图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="堆叠面积图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/area/#stacked-area"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*Cla-RK74-GgAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>堆叠面积图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="彩条图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/area/#orderly-area"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*-NZbR5vNY28AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>彩条图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="河流图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/area/#streamgraph"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*LeTWR4RrSjoAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>河流图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="归一化堆叠面积图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/area/#percentage-area"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*Pp6-RJMKJFUAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>归一化堆叠面积图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="出现顺序堆叠面积图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/area/#cascade-area"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*Pgc7Q4K0cFwAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>出现顺序堆叠面积图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="面积图特殊标签">
                      <a class="X6AtY7FPSlY8cpJZ7YgY" hrefCustom="/examples/general/area/#label"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*IE5nQIEJOnsAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>面积图特殊标签</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="差分面积图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/area/#area-difference"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*9jOYSrMpSe4AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>差分面积图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="板子图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/area/#area-band"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*2fXdTp9E-uwAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>板子图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="区间面积图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/area/#area-range"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*HlorR55MDE4AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>区间面积图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="区间曲线面积图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/area/#range-spline-area"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*ln0-RKKu520AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>区间曲线面积图</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="general-cell">色块图</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="华夫饼图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/cell/#cell-basic"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*F8DLSYJAyKQAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>华夫饼图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="热力图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/cell/#cell-heatmap"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/mdn/huamei_qa8qxu/afts/img/A*XYedR7WEoUEAAAAAAAAAAAAADmJ7AQ');
                          "
                        ></div>
                        <h4>热力图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="阈值热力图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/cell/#cell-threshold"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/mdn/huamei_qa8qxu/afts/img/A*RcOMSq6qcFAAAAAAAAAAAAAADmJ7AQ');
                          "
                        ></div>
                        <h4>阈值热力图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="分位数热力图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/cell/#cell-quantile"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/mdn/huamei_qa8qxu/afts/img/A*i8u2RLyueqgAAAAAAAAAAAAADmJ7AQ');
                          "
                        ></div>
                        <h4>分位数热力图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="量化热力图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/cell/#cell-quantize"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/mdn/huamei_qa8qxu/afts/img/A*gWiuQqMJ-TAAAAAAAAAAAAAADmJ7AQ');
                          "
                        ></div>
                        <h4>量化热力图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="聚合热力图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/cell/#cell-aggregated"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/mdn/huamei_qa8qxu/afts/img/A*Wk4zR40uQesAAAAAAAAAAAAADmJ7AQ');
                          "
                        ></div>
                        <h4>聚合热力图</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="general-pie">饼图</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="简单饼图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/pie/#pie-base"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*1yoaSJ0rfrYAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>简单饼图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="简单环图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/pie/#donut-base"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*06RqSKmmVbEAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>简单环图</h4></a
                      >
                    </li>
                    <li
                      class="RmkpYWHI9d4RYQiIr3CY"
                      title="2018 年第一季度短视频用户性别分布"
                    >
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/pie/#pie-base-facet"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*enGVRIWj9KUAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>2018 年第一季度短视频用户性别分布</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="饼图">
                      <a class="X6AtY7FPSlY8cpJZ7YgY" hrefCustom="/examples/general/pie/#pie"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*xuKWQoLfxjwAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>饼图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="饼图, 中心文本">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/pie/#pie-donut-text"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*ce-SSKsG36EAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>饼图, 中心文本</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="甜甜圈图">
                      <a class="X6AtY7FPSlY8cpJZ7YgY" hrefCustom="/examples/general/pie/#donut"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*LUQlSaccoLcAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>甜甜圈图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="饼图, 蜘蛛布局标签">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/pie/#spider-label"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*gC20SLxWVicAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>饼图, 蜘蛛布局标签</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="径向扰动散点图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/pie/#point-jitter-radial"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*DziRQb4LMbAAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>径向扰动散点图</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="general-dual">多轴图</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title=" 柱线混合">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/dual/#line-bar"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*A-m1SKg_JAAAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>柱线混合</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="多轴图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/dual/#multi-line"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/mdn/huamei_qa8qxu/afts/img/A*BxouQYIIQ0kAAAAAAAAAAAAADmJ7AQ/fmt.webp');
                          "
                        ></div>
                        <h4>多轴图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="聚合线面双轴图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/dual/#dual-aggregated-line-area"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/mdn/huamei_qa8qxu/afts/img/A*J-lVRamRfgUAAAAAAAAAAAAADmJ7AQ');
                          "
                        ></div>
                        <h4>聚合线面双轴图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="帕累托图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/dual/#pareto"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*dy4HQ7kqYd0AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>帕累托图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="双轴条形图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/dual/#dual-axis-bar"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*WW9wRaGxuDAAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>双轴条形图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="双轴折线条形图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/dual/#dual-axis-line-bar"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*FVRbQ7jbi0oAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>双轴折线条形图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="双轴多折线条形图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/dual/#dual-axis-multi-line-bar"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*gER1QbKH7IIAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>双轴多折线条形图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="双轴堆叠分组条形图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/dual/#dual-axis-stacked-group-bar"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*lfupS49PdxAAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>双轴堆叠分组条形图</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="general-rose">玫瑰图</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="玫瑰图">
                      <a class="X6AtY7FPSlY8cpJZ7YgY" hrefCustom="/examples/general/rose/#rose"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*Trl1TqdieqIAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>玫瑰图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="堆叠玫瑰图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/rose/#stacked-rose"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*W9NLQriv7w0AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>堆叠玫瑰图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="玫瑰图标签">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/rose/#rose-label"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*rS9YT4GTFLgAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>玫瑰图标签</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="general-radial">径向图</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="玉珏图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/radial/#bar-radial"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*TVXmRq627aEAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>玉珏图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="圆角玉珏图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/radial/#bar-cornered-radial"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*2Xd0Sq0iq7gAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>圆角玉珏图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="Apple 活动图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/radial/#apple-activity"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/mdn/huamei_qa8qxu/afts/img/A*o3j-SZCiTZwAAAAAAAAAAAAADmJ7AQ');
                          "
                        ></div>
                        <h4>Apple 活动图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="带背景的玉珏图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/radial/#radial-bar-with-background"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*9FxwQIEcoDMAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>带背景的玉珏图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="径向堆叠条形图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/radial/#radial-stacked"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*T3NtSLBLc0sAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>径向堆叠条形图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="径向条形图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/radial/#radial-line"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*h3MESLqnM4QAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>径向条形图</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="general-radar">雷达图</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="雷达图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/radar/#radar"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*-xcxS7E8sKcAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>雷达图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="雷达图(带网格)">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/radar/#grid-radial"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*zRVhQKaw1zwAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>雷达图(带网格)</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="雷达图(带底色)">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/radar/#radial-with-background-color"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*jjhCTKfZHpgAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>雷达图(带底色)</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="复杂雷达图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/radar/#complex-radial"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*xjsASojtRJgAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>复杂雷达图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="雷达图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/radar/#parallel-radar"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*4sqyTZUFCNkAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>雷达图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="径向面积图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/radar/#area-radial"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/mdn/huamei_qa8qxu/afts/img/A*-m-2QolJUt0AAAAAAAAAAAAADmJ7AQ');
                          "
                        ></div>
                        <h4>径向面积图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="方形雷达图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/radar/#square-radar"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*JBvBT5c5_2sAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>方形雷达图</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="general-parallel">平行坐标系</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="竖直平行坐标系">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/parallel/#line-parallel-vertical"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/mdn/huamei_qa8qxu/afts/img/A*aX6WSJw7proAAAAAAAAAAAAADmJ7AQ');
                          "
                        ></div>
                        <h4>竖直平行坐标系</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="水平平行坐标系">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/parallel/#line-parallel-horizontal"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/mdn/huamei_qa8qxu/afts/img/A*SOZOT7Smha0AAAAAAAAAAAAADmJ7AQ');
                          "
                        ></div>
                        <h4>水平平行坐标系</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="general-candlestick">股票图</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="股票图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/candlestick/#line-candle-stick"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/mdn/huamei_qa8qxu/afts/img/A*IXIkSa7SW2sAAAAAAAAAAAAADmJ7AQ');
                          "
                        ></div>
                        <h4>股票图</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="general-link">连接图</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="箭线">
                      <a class="X6AtY7FPSlY8cpJZ7YgY" hrefCustom="/examples/general/link/#link"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*fjoBSKcG2lMAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>箭线</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="Link 辅助线">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/link/#link-annotation"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*b6WrQ4PYPCoAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>Link 辅助线</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="general-vector">向量场</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="风向量场">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/vector/#wind"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*1LQ2Sbpwl6YAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>风向量场</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="珀林噪声场">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/vector/#poisson"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*uZwwQLVg1yYAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>珀林噪声场</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="general-box">箱线图</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="预处理箱线图">
                      <a class="X6AtY7FPSlY8cpJZ7YgY" hrefCustom="/examples/general/box/#box"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*fykJSJFMPtQAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>预处理箱线图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="预处理分组箱线图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/box/#grouped-box"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*CqOoTa4Y4GAAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>预处理分组箱线图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="无异常点箱线图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/box/#boxplot"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*yuoXSJhQol0AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>无异常点箱线图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="带异常点箱线图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/box/#boxplot-outlier"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*PxD1QZ8xRsIAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>带异常点箱线图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="带异常点分组箱线图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/box/#grouped-boxplot-outlier"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*jHAhR5NH2OQAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>带异常点分组箱线图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="一维箱线图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/box/#boxplot-1d"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*DsE6S4ZS-68AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>一维箱线图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="径向箱线图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/box/#polar-box"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*H3feTr-k4XQAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>径向箱线图</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="general-text">文本</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="文本段落">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/text/#paragraph"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*W9TRQJd7BbsAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>文本段落</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="诗词可视化">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/text/#poetry"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*hKf9TbJEeooAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>诗词可视化</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="火车调度">
                      <a class="X6AtY7FPSlY8cpJZ7YgY" hrefCustom="/examples/general/text/#train"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*9oS5TKxuK-MAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>火车调度</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="词云图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/text/#wordCloud"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*0xE1T7W2Oq4AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>词云图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="英文字符词云图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/text/#wordCloud-english"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*H6BoRoDMolwAAAAAAAAAAAAADmJ7AQ/fmt.webp');
                          "
                        ></div>
                        <h4>英文字符词云图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="带图片遮罩的词云图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/text/#wordCloud-mask"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*P6MoSriYWhkAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>带图片遮罩的词云图</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="general-image">图片</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="浏览器图标">
                      <a class="X6AtY7FPSlY8cpJZ7YgY" hrefCustom="/examples/general/image/#logo"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*R8TRQJMrQ-AAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>浏览器图标</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title=" 图标标记">
                      <a class="X6AtY7FPSlY8cpJZ7YgY" hrefCustom="/examples/general/image/#icon"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*CKmISLNs5FAAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>图标标记</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="贡献者">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/image/#contributor"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*zD2UToZzYloAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>贡献者</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="general-gauge">仪表盘</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="仪表盘">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/gauge/#gauge-default"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*hpjTRr6LM7IAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>仪表盘</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="自定义仪表盘颜色">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/gauge/#gauge-custom-color"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*vE7cR6ZHHk0AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>自定义仪表盘颜色</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="仪表盘内置 round 形状">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/gauge/#gauge-round"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*_tUeQ64QNVEAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>仪表盘内置 round 形状</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="general-Liquid">水波图</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="水波图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/Liquid/#liquid-default"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_za7we3/afts/img/A*cHArRaizyBsAAAAAAAAAAAAADo2bAQ/original');
                          "
                        ></div>
                        <h4>水波图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="水波图 文本内容">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/Liquid/#liquid-content"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*5ZT3R4yo_3kAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>水波图 文本内容</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="水滴形状水波图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/Liquid/#liquid-pin"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_za7we3/afts/img/A*G5TyT4PNLK0AAAAAAAAAAAAADo2bAQ/original');
                          "
                        ></div>
                        <h4>水滴形状水波图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="带背景的水波图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/Liquid/#liquid-background"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_za7we3/afts/img/A*QgkTSq1OdvoAAAAAAAAAAAAADo2bAQ/original');
                          "
                        ></div>
                        <h4>带背景的水波图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="自定义形状水波图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/Liquid/#liquid-custom-shape"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_za7we3/afts/img/A*LYOpQLfrlqMAAAAAAAAAAAAADo2bAQ/original');
                          "
                        ></div>
                        <h4>自定义形状水波图</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="general-sunburst">旭日图</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="旭日图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/sunburst/#sunburst-default"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*Wk2MRYp8VO4AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>旭日图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="旭日图带标签">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/sunburst/#sunburst-label"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*GBxdT697NYQAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>旭日图带标签</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="旭日图自定义颜色通道">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/sunburst/#sunburst-color"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*7L4tQ4F61ZkAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>旭日图自定义颜色通道</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="旭日图自定义样式">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/sunburst/#sunburst-style"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*BP7zQ6SMiKcAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>旭日图自定义样式</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="旭日图自定义纹理">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/sunburst/#sunburst-pattern"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*rVCgTqydP5kAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>旭日图自定义纹理</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="旭日图交互配置">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/sunburst/#sunburst-interaction"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*7C0NQK9_TfwAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>旭日图交互配置</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="general-funnel">漏斗图</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="漏斗图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/funnel/#funnel"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*9GDLQpMor0oAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>漏斗图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="金字塔图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/funnel/#pyramid"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*VpuRSZGqnlUAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>金字塔图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="对比漏斗图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/funnel/#mirror-funnel"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*ejYqRJVJ12gAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>对比漏斗图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="转化漏斗图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/funnel/#funnel-annotation"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*P_kASqVFAzoAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>转化漏斗图</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="general-bullet">子弹图</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="子弹图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/bullet/#bullet"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_za7we3/afts/img/A*rRZQQ6I4Ic4AAAAAAAAAAAAADo2bAQ/original');
                          "
                        ></div>
                        <h4>子弹图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="子弹图 更多数据">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/bullet/#bullet-datas"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_za7we3/afts/img/A*fHiHTrdGO10AAAAAAAAAAAAADo2bAQ/original');
                          "
                        ></div>
                        <h4>子弹图 更多数据</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="多条子弹图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/bullet/#bullets"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_za7we3/afts/img/A*wTXUQoxeACgAAAAAAAAAAAAADo2bAQ/original');
                          "
                        ></div>
                        <h4>多条子弹图</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="general-mini">迷你图</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="迷你折线图">
                      <a class="X6AtY7FPSlY8cpJZ7YgY" hrefCustom="/examples/general/mini/#line"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*oIAqSKbh60cAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>迷你折线图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="迷你面积图">
                      <a class="X6AtY7FPSlY8cpJZ7YgY" hrefCustom="/examples/general/mini/#area"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*e7gFTKK4RXwAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>迷你面积图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="迷你柱形图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/mini/#column"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*mVxXQZLTI8UAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>迷你柱形图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="迷你饼图">
                      <a class="X6AtY7FPSlY8cpJZ7YgY" hrefCustom="/examples/general/mini/#pie"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*Y4-MR51q9sEAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>迷你饼图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="迷你进度条">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/mini/#progress"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*ZJ6JSL4WFt8AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>迷你进度条</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="迷你环图">
                      <a class="X6AtY7FPSlY8cpJZ7YgY" hrefCustom="/examples/general/mini/#ring"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*9K68TYbHx7IAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>迷你环图</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="general-violin">小提琴图</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="和密度图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/violin/#density"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*-EcIQ7sKufsAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>和密度图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="小提琴图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/violin/#violin"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*QXpmQaR71yYAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>小提琴图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="极坐标小提琴图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/violin/#violin-polar"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*r027Q4SUC3kAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>极坐标小提琴图</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="general-heatmap">热力图</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="密度热力图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/heatmap/#heatmap"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*ze7gSYylw_QAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>密度热力图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="散点分布热力">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/heatmap/#heatmap-density"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*0AfVQpGgcsoAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>散点分布热力</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="鼠标热力图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/heatmap/#mouse-heatmap"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*kC58R7TEdd0AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>鼠标热力图</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="general-venn">韦恩图</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="韦恩图">
                      <a class="X6AtY7FPSlY8cpJZ7YgY" hrefCustom="/examples/general/venn/#venn"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*uJF2T7anbQUAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>韦恩图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="空心韦恩图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/general/venn/#venn-hollow"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*lAPPSaOWGXYAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>空心韦恩图</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="analysis-bin">分箱</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="直方图">
                      <a class="X6AtY7FPSlY8cpJZ7YgY" hrefCustom="/examples/analysis/bin/#binx"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*WJFaSp1JLHQAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>直方图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="颜色分类直方图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/analysis/bin/#binx-color"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*l6NBRburGGcAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>颜色分类直方图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="颜色分箱">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/analysis/bin/#bin-color"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*oyXhQKobcMMAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>颜色分箱</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="透明度分箱">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/analysis/bin/#bin-opacity"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*REZQSLd63dYAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>透明度分箱</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="大小分箱">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/analysis/bin/#bin-size"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*OTA1TLuF-l4AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>大小分箱</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="泊松分布">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/analysis/bin/#poisson"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*1YpETqJXr9QAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>泊松分布</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="analysis-group">分组</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="层叠条形图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/analysis/group/#bar-layered"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*HYb2Rqy2ZCIAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>层叠条形图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="发散堆叠条形图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/analysis/group/#bar-stacked-diverging"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*UbIuS5Xz51wAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>发散堆叠条形图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="聚合条形图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/analysis/group/#bar-aggregated"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*ZMTCT50nmwcAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>聚合条形图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="聚合堆叠条形图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/analysis/group/#bar-aggregated-stacked"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*fY5CTLQMv4IAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>聚合堆叠条形图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="聚合归一化堆叠条形图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/analysis/group/#bar-aggregated-normalized-stacked"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*1oZjT4cKSh8AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>聚合归一化堆叠条形图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="一维聚合堆叠条形图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/analysis/group/#bar-stacked-normalized-1d"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*dWoBQ7aVlcQAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>一维聚合堆叠条形图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="多度量条形图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/analysis/group/#bar-multi-measure"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/mdn/huamei_qa8qxu/afts/img/A*-JCwSpV0pAsAAAAAAAAAAAAADmJ7AQ');
                          "
                        ></div>
                        <h4>多度量条形图</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="analysis-regression">回归线</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="线性回归线">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/analysis/regression/#linear-regression"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*px9zQYKi5FsAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>线性回归线</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="二项式回归线">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/analysis/regression/#quadratic-regression"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*4C26SqNkoG8AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>二项式回归线</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="指数回归线">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/analysis/regression/#exponential-regression"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*tPkpRqqP7rsAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>指数回归线</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="对数回归线">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/analysis/regression/#logarithmic-regression"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*onhxRaj8iP0AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>对数回归线</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="多项式回归线">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/analysis/regression/#polynomial-regression"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*SXUpRZiOlbIAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>多项式回归线</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="graph-hierarchy">树</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="矩阵树图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/graph/hierarchy/#treemap"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*BD2zQIr7D5MAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>矩阵树图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="矩阵树图下钻">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/graph/hierarchy/#treemap-drill-down"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*FwWXQqqpc_UAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>矩阵树图下钻</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="打包图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/graph/hierarchy/#circle-packing"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*epG0TaxEVTsAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>打包图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="树图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/graph/hierarchy/#tree"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*MQL0S54pP7kAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>树图</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="graph-network">网络</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="桑基图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/graph/network/#sankey"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*dACBR7ANcfEAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>桑基图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="弦图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/graph/network/#chord"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*AwKoTakLlHAAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>弦图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="力导向图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/graph/network/#forceGraph"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*nbN4TYyfq70AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>力导向图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="离散力导向图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/graph/network/#forceGraph-disjoint"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*0eUHS6s10m8AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>离散力导向图</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="geo-geo">地图</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="美国行政地图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/geo/geo/#choropleth-usa"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*vcI7RqX24U0AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>美国行政地图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="航班机场图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/geo/geo/#flights-airports"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*mVdhSZ1wvDgAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>航班机场图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="伦敦地铁图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/geo/geo/#london-tube-lines"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*CQ4iT4UbQmAAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>伦敦地铁图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="世界地图">
                      <a class="X6AtY7FPSlY8cpJZ7YgY" hrefCustom="/examples/geo/geo/#world-map"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*qW_OT4OkivEAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>世界地图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="投影比较">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/geo/geo/#projection-comparison"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*eM7qSrDEZcYAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>投影比较</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="六边形美国地图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/geo/geo/#hexjson-usa"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*BAtYRoaNsp4AAAAAAAAAAAAADmJ7AQ/fmt.webp');
                          "
                        ></div>
                        <h4>六边形美国地图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="六边形中国地图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/geo/geo/#hexbin-china"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*T0WkT5NCw7UAAAAAAAAAAAAADmJ7AQ/fmt.webp');
                          "
                        ></div>
                        <h4>六边形中国地图</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="annotation-text">文本标注</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="文本标记的折线图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/annotation/text/#line-text"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/mdn/huamei_qa8qxu/afts/img/A*pQq2S7Ns2MUAAAAAAAAAAAAADmJ7AQ');
                          "
                        ></div>
                        <h4>文本标记的折线图</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="annotation-line">线标注</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="平均值线标注的直方图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/annotation/line/#histogram-mean-line"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*VJVAT7Rkx9MAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>平均值线标注的直方图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="平均值线标注的柱状图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/annotation/line/#interval-mean-line"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*BG5UTbE7gycAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>平均值线标注的柱状图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="突出超出阈值的柱状图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/annotation/line/#interval-threshold"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*-seGQa_dPyoAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>突出超出阈值的柱状图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="线标记的散点图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/annotation/line/#point-line"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*KsPIR7q6BO0AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>线标记的散点图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="点标记的散点图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/annotation/line/#point-point"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/mdn/huamei_qa8qxu/afts/img/A*rWBUQ6_kf8kAAAAAAAAAAAAADmJ7AQ');
                          "
                        ></div>
                        <h4>点标记的散点图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="区域标记的四象限散点图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/annotation/line/#quadrant-scatter"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/mdn/huamei_qa8qxu/afts/img/A*6JLeTLg7YQoAAAAAAAAAAAAADmJ7AQ');
                          "
                        ></div>
                        <h4>区域标记的四象限散点图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="异动趋势图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/annotation/line/#anomaly-area-line"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*DdeURpZKfwAAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>异动趋势图</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="annotation-connector">连接标注</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="链接线标记的瀑布图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/annotation/connector/#interval-connector"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*9BOSQozPCx4AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>链接线标记的瀑布图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="线标记的瀑布图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/annotation/connector/#revenue-flow-waterfall"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*qRAFQqfcyygAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>线标记的瀑布图</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="annotation-range">区间标注</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="区域标记的散点图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/annotation/range/#point-range"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*w1BBRYvJf_UAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>区域标记的散点图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="区间标注的折线图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/annotation/range/#line-range"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*OCgJSIpz7KMAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>区间标注的折线图</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="annotation-shape">图形标注</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="点标记的条形图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/annotation/shape/#interval-point"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*ypE2SbuV6kwAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>点标记的条形图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="徽章标记的折线图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/annotation/shape/#line-badge"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*INjOS7ExVzYAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>徽章标记的折线图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="徽章水印">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/annotation/shape/#watermark"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*LA11Rqfk2Y4AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>徽章水印</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="composition-space">空间复合</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="层叠容器">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/composition/space/#space-layer"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*wlGJTKOP2L4AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>层叠容器</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="弹性容器">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/composition/space/#space-flex"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*Cc53QaoWAQ0AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>弹性容器</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="composition-facet">分面复合</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="行矩行分面">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/composition/facet/#rect-row"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/mdn/huamei_qa8qxu/afts/img/A*duq8TrR0LxcAAAAAAAAAAAAADmJ7AQ');
                          "
                        ></div>
                        <h4>行矩行分面</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="列矩行分面">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/composition/facet/#rect-col"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*21B-Qa-dWPMAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>列矩行分面</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="矩行分面">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/composition/facet/#rect"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*GwKzQ66lGqYAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>矩行分面</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="日历条形图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/composition/facet/#rect-bar"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*ZVOtQ4Bmir0AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>日历条形图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="日历饼图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/composition/facet/#rect-pie"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*USKZRKqpAvgAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>日历饼图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="圆形分面">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/composition/facet/#circle"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*V61eQY0Qs4cAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>圆形分面</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="自定义视图边框">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/composition/facet/#rect-frame"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*aofoR4mGPVUAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>自定义视图边框</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="composition-repeat">重复复合</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="列重复矩阵">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/composition/repeat/#matrix-col"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*1vHlSIQnIqgAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>列重复矩阵</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="重复矩阵">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/composition/repeat/#matrix"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*AT8rSbCrQJwAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>重复矩阵</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="component-axis">坐标轴</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="x 方向坐标轴">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/component/axis/#axis-x"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*kcACSYV4r-cAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>x 方向坐标轴</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="x 和 y 方向坐标轴">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/component/axis/#axis-xy"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*84x4RKr1uA8AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>x 和 y 方向坐标轴</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="极坐标下坐标轴">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/component/axis/#axis-polar"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*s_KgSKR6XeIAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>极坐标下坐标轴</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="多坐标轴">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/component/axis/#axis-multi"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*aeDQQqTlA1sAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>多坐标轴</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="自定义坐标轴标签">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/component/axis/#axis"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*NEbsT6qCFSEAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>自定义坐标轴标签</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="component-legend">图例</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="自定义图例标签">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/component/legend/#category"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*dd0oR5_JfToAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>自定义图例标签</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="连续图例">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/component/legend/#continuous"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*QXuAQ7COJwcAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>连续图例</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="自定义图例">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/component/legend/#custom"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*mZFvTZtdBEUAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>自定义图例</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="component-tooltip">提示</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="提示">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/component/tooltip/#tooltip"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*1ipfQ7p3x3wAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>提示</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="多维度提示">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/component/tooltip/#tooltip2d"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*Zz3WSoLucjsAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>多维度提示</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="系列提示">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/component/tooltip/#tooltip-series"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*_-nwR4i4dmoAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>系列提示</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="自定义提示">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/component/tooltip/#tooltip-custom"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*tELLRr-YVa8AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>自定义提示</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="自定义渲染内容">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/component/tooltip/#tooltip-render"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*seQRQrEFOBoAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>自定义渲染内容</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="点击提示">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/component/tooltip/#tooltip-click"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*OZz0RZle0tsAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>点击提示</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="自定义样式">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/component/tooltip/#tooltip-style"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*2uARSYuGfPgAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>自定义样式</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="component-label">数据标签</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="数据标签碰撞隐藏">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/component/label/#overlapHide"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*d3PIQKO4qpoAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>数据标签碰撞隐藏</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="数据标签超出隐藏">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/component/label/#overflowHide"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*nBSvRaadPpYAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>数据标签超出隐藏</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="数据标签颜色反转">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/component/label/#contrastReverse"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*uCijTZ64mdQAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>数据标签颜色反转</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="HTML 标签">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/component/label/#htmlLabel"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*OMnRQ5IgftkAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>HTML 标签</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="component-scrollbar">滚动条</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="滚动条">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/component/scrollbar/#scrollbar"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*SYeoT6E_CmMAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>滚动条</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="animation-general">过渡动画</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="PathIn">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/animation/general/#path-in"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*uq_2SL14wgQAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>PathIn</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="FadeIn">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/animation/general/#fade"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*lW80R5AYDfEAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>FadeIn</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="ScaleInX">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/animation/general/#scale-x"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*4j9URodi54MAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>ScaleInX</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="ScaleInY">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/animation/general/#scale-y"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*u5QxT7pZD68AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>ScaleInY</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="WaveIn">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/animation/general/#wave-in"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*xL5hQ5TCR4cAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>WaveIn</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="ZoomIn">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/animation/general/#zoom-in"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*OE0wRJhaM3cAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>ZoomIn</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="animation-group">分组动画</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="折线图动画">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/animation/group/#line"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*dxClRrq57JMAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>折线图动画</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="柱形图动画">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/animation/group/#interval"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*3xCLRLNfv7EAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>柱形图动画</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="玫瑰图动画">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/animation/group/#interval-polar"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*dG5TQ6IDBN0AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>玫瑰图动画</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="面积图动画">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/animation/group/#area"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*sh4JSao3tVgAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>面积图动画</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="点图动画">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/animation/group/#point"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://gw.alipayobjects.com/zos/raptor/1668858139680/point-animation.gif');
                          "
                        ></div>
                        <h4>点图动画</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="animation-lottie">Lottie 动画</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="Lottie">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/animation/lottie/#lottie"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://gw.alipayobjects.com/zos/raptor/1668077308397/Nov-10-2022%25252018-48-07.gif');
                          "
                        ></div>
                        <h4>Lottie</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="interaction-element">元素</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="高亮">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/interaction/element/#highlight"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*h3zzSqWMrDkAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>高亮</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="选择">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/interaction/element/#select"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*gwt_SpgIGsMAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>选择</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="interaction-component">组件</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="图例">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/interaction/component/#legend"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*bxrsS55V3Y4AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>图例</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="interaction-brush">刷选</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="刷选">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/interaction/brush/#brush"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*ESblSJqW3zYAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>刷选</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="刷选事件">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/interaction/brush/#brush-emit"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*kWbhQKMQp9wAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>刷选事件</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="interaction-data">数形交互</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="折线图-数形交互">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/interaction/data/#line-element-point-move"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*XO4yQqSSeSoAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>折线图-数形交互</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="面积图-数形交互">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/interaction/data/#area-element-point-move"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*FTm7T5CfHsUAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>面积图-数形交互</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="面积图-百分比堆叠-数形交互">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/interaction/data/#area-normalizeY-element-point-move"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*xWt3R5fzwH4AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>面积图-百分比堆叠-数形交互</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="柱形图-数形交互">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/interaction/data/#column-element-point-move"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*fZn9TYPR2mcAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>柱形图-数形交互</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="柱形图-百分比堆叠-数形交互">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/interaction/data/#column-normalizeY-element-point-move"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*G5a8T7lP0ZEAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>柱形图-百分比堆叠-数形交互</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="条形图-数形交互">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/interaction/data/#bar-element-point-move"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*WQnwTJ-gJq0AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>条形图-数形交互</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="条形图-百分比堆叠-数形交互">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/interaction/data/#bar-normalizeY-element-point-move"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*SDtmQrDx7cAAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>条形图-百分比堆叠-数形交互</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="雷达图-数形交互">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/interaction/data/#line-element-point-move-polar"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*ifgPT565BPkAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>雷达图-数形交互</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="饼图-数形交互">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/interaction/data/#pie-element-point-move"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*Hm0PR5262sgAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>饼图-数形交互</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="interaction-other">其他</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="索引图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/interaction/other/#chart-index"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*LaVjRbRk8EcAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>索引图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="鱼眼">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/interaction/other/#fisheye"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*FwusQ6ohkqkAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>鱼眼</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="interaction-multi-view">多视图</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="图表联动">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/interaction/multi-view/#focus-context"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*IwNsRKKyMlgAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>图表联动</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="intelligent-auto">自动可视化</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="自动可视化 - 饼图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/intelligent/auto/#auto-pie"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*wiMbSY4kNwkAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>自动可视化 - 饼图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="自动可视化 - 散点图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/intelligent/auto/#auto-scatter"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*SxISRpCBszgAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>自动可视化 - 散点图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="自动可视化 - 柱形图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/intelligent/auto/#auto-interval"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*hJtlRIGnjpsAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>自动可视化 - 柱形图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="自动可视化 - 折线图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/intelligent/auto/#auto-line"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*n12qQJ6JmMgAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>自动可视化 - 折线图</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="intelligent-insight">洞察标注</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="趋势">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/intelligent/insight/#trend"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*DweUTbVAaIEAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>趋势</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="时序异常">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/intelligent/insight/#time-series-outlier"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*N5OkR5VKYMAAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>时序异常</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="低方差">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/intelligent/insight/#low-variance"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*Y0QJSZSbig8AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>低方差</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="突变点">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/intelligent/insight/#change-point"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*_p5WRZAmT1oAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>突变点</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="类别异常">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/intelligent/insight/#category-outlier"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*B64DT43QAVMAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>类别异常</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="洞察标注算法的详细参数">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/intelligent/insight/#insight"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*DweUTbVAaIEAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>洞察标注算法的详细参数</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="storytelling-storytelling">可视化叙事</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="甘特图动画">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/storytelling/storytelling/#gantt"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*hyB5RIY-qcMAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>甘特图动画</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="条帧动画">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/storytelling/storytelling/#interval-keyframe"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*Nmz5Rb8rvOgAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>条帧动画</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="点帧动画">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/storytelling/storytelling/#point-keyframe"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*MOozSI2JRJIAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>点帧动画</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="分面帧动画">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/storytelling/storytelling/#facet-keyframe"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*vtjDQ4sJHJkAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>分面帧动画</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="混合帧动画">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/storytelling/storytelling/#stocks-keyframe"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*oJvJS4QL8u0AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>混合帧动画</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="algorithm-sort">排序</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="冒泡排序">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/algorithm/sort/#bubble-sort"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*lSdRQZt-_BsAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>冒泡排序</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="选择排序">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/algorithm/sort/#selection-sort"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*STlaRaqEa6MAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>选择排序</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="插入排序">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/algorithm/sort/#insertion-sort"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*MbFLR46PNEcAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>插入排序</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="unit-unit">单元可视化</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="基础">
                      <a class="X6AtY7FPSlY8cpJZ7YgY" hrefCustom="/examples/unit/unit/#basic"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*TZmeQqK7CZwAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>基础</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="共享尺寸定义域">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/unit/unit/#share-size"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*QQIBRrgnC10AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>共享尺寸定义域</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="共享数据定义域">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/unit/unit/#share-data"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*Xqf_TLXa4IAAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>共享数据定义域</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="二维">
                      <a class="X6AtY7FPSlY8cpJZ7YgY" hrefCustom="/examples/unit/unit/#2d"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*JLcrS5ftzXoAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>二维</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="嵌套">
                      <a class="X6AtY7FPSlY8cpJZ7YgY" hrefCustom="/examples/unit/unit/#nested"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*F2_7T4keuwgAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>嵌套</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="threed-scatter">3D 散点图</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="正交投影">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/threed/scatter/#orthographic-projection"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*7MdMQY-QksEAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>正交投影</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="透视投影">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/threed/scatter/#perspective-projection"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*KNCUQqzw2JsAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>透视投影</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="球体">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/threed/scatter/#sphere-shape"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*8t0aRJLbhuwAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>球体</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="圆形">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/threed/scatter/#circle-shape"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*JyzNSp6_T30AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>圆形</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="三角形">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/threed/scatter/#triangle-shape"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*q1-TQZnlXAQAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>三角形</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="正方形">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/threed/scatter/#square-shape"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*chMwT6y5MDwAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>正方形</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="自定义图例">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/threed/scatter/#custom-legend"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*SmF_Ro5UYcwAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>自定义图例</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="相机动画">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/threed/scatter/#camera-animation"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*ffrAS7t1EDcAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>相机动画</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="threed-line">3D 折线图</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="折线">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/threed/line/#polyline"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*0MEPQrNRlvoAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>折线</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="螺旋线">
                      <a class="X6AtY7FPSlY8cpJZ7YgY" hrefCustom="/examples/threed/line/#spiral"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*Ak1iTZ1dpI0AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>螺旋线</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="threed-bar">3D 柱状图</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="立方体">
                      <a class="X6AtY7FPSlY8cpJZ7YgY" hrefCustom="/examples/threed/bar/#cube"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*8SliSolQ6_0AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>立方体</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="圆柱">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/threed/bar/#cylinder"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*D1UGQ7TE1D0AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>圆柱</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="圆锥">
                      <a class="X6AtY7FPSlY8cpJZ7YgY" hrefCustom="/examples/threed/bar/#cone"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*PpF2SZMBW-wAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>圆锥</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="threed-surface">3D 曲面图</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="狄利克雷分布">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/threed/surface/#dirichlet"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*4LJeR4SqvEoAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>狄利克雷分布</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="三角函数">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/threed/surface/#trigonometric"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*CT7VQrD32DkAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>三角函数</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="interesting-interesting">趣味可视化</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="花瓣图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/interesting/interesting/#petal"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*kIJxRbm2HTIAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>花瓣图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="梅西射门分析">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/interesting/interesting/#messi"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*N6mYTas3VIgAAAAAAAAAAAAADmJ7AQ/fmt.webp');
                          "
                        ></div>
                        <h4>梅西射门分析</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="2.5D 柱形图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/interesting/interesting/#25d-column"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*GThCTqSNiSkAAAAAAAAAAAAADmJ7AQ/fmt.webp');
                          "
                        ></div>
                        <h4>2.5D 柱形图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="时间轴 Timeline">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/interesting/interesting/#timeline"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*NUHAS79kw-kAAAAAAAAAAAAADmJ7AQ/fmt.webp');
                          "
                        ></div>
                        <h4>时间轴 Timeline</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="style-theme">主题</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="暗色风格">
                      <a class="X6AtY7FPSlY8cpJZ7YgY" hrefCustom="/examples/style/theme/#dark"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*75B7Qov83a0AAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>暗色风格</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="学术风格">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/style/theme/#academy"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*lin8SZ8z5fUAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>学术风格</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="视图模型">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/style/theme/#layout-area"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*IOiTQ47rrzwAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>视图模型</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="style-rough">手绘</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="手绘折线图">
                      <a class="X6AtY7FPSlY8cpJZ7YgY" hrefCustom="/examples/style/rough/#line"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*rWRtR4hZCAAAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>手绘折线图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="手绘散点图">
                      <a class="X6AtY7FPSlY8cpJZ7YgY" hrefCustom="/examples/style/rough/#point"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*TZKwSI7nJXEAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>手绘散点图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="手绘条形图">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/style/rough/#interval"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*FYCJSaa_NBMAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>手绘条形图</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="手绘饼图">
                      <a class="X6AtY7FPSlY8cpJZ7YgY" hrefCustom="/examples/style/rough/#radial"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/mdn/huamei_qa8qxu/afts/img/A*kJuuQ47YUicAAAAAAAAAAAAADmJ7AQ');
                          "
                        ></div>
                        <h4>手绘饼图</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="style-pattern">纹理</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="Lines Pattern">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/style/pattern/#lines-pattern"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*Pf4HQJPkQxYAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>Lines Pattern</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="Dots Pattern">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/style/pattern/#dots-pattern"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*xqeOR6l10bUAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>Dots Pattern</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="Squares Pattern">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/style/pattern/#squares-pattern"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*YFY0T5U18PEAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>Squares Pattern</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="使用 G API 自定义 Pattern">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/style/pattern/#custom-pattern-with-g-api"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*W33JRoaMGPoAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>使用 G API 自定义 Pattern</h4></a
                      >
                    </li>
                    <li
                      class="RmkpYWHI9d4RYQiIr3CY"
                      title="使用原生 Canvas API 自定义 Pattern"
                    >
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/style/pattern/#custom-pattern-with-canvas"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*W33JRoaMGPoAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>使用原生 Canvas API 自定义 Pattern</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="renderer-renderer">渲染器</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="Canvas 渲染器">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/renderer/renderer/#canvas"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*vai7QIfDI_AAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>Canvas 渲染器</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="SVG 渲染器">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/renderer/renderer/#svg"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*ZJB1TZ0REDAAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>SVG 渲染器</h4></a
                      >
                    </li>
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="WebGL 渲染器">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/renderer/renderer/#webgl"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*l504TZE8laUAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>WebGL 渲染器</h4></a
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <h2 id="accessible-text-searching">文本搜索</h2>
                  <ul class="v90vC3gZt54Nwza4KgSs">
                    <li class="RmkpYWHI9d4RYQiIr3CY" title="Ctrl/⌘+F 文本搜索">
                      <a
                        class="X6AtY7FPSlY8cpJZ7YgY"
                        hrefCustom="/examples/accessible/text-searching/#text-search"
                        ><div
                          class="demo-card-screenshot UoWLG9mnhIsRxu4NYc4v"
                          style="
                            background-image: url('https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*TehBRbDnoIkAAAAAAAAAAAAADmJ7AQ/original');
                          "
                        ></div>
                        <h4>Ctrl/⌘+F 文本搜索</h4></a
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="ant-back-top" style="right: 32px"></div>
          </div>
        </article>
      </main>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    title: {
      type: Boolean,
      default: false,
    },
  },
  methods: {},
  mounted() {},
};
</script>

<style scoped lang="less">
.content {
  padding: 0 !important;
}
.ncQo0JB1pJEd3mDsmCk7{width:50%;display:inline-block;margin-top:32px;padding:32px 0 0;cursor:pointer;border-top:1px solid #e8e8e8;line-height:1.5;vertical-align:top}.ncQo0JB1pJEd3mDsmCk7.nGwRnowWCDs7XZtu9LMg{height:86px;cursor:auto}.ncQo0JB1pJEd3mDsmCk7 .fmYEWi3aLuMRsZI1o_Ol{margin-bottom:8px;font-size:14px;color:#bfbfbf}.ncQo0JB1pJEd3mDsmCk7 .D08VzPpgn40iEjlhtU7s{font-size:16px;font-weight:500;color:#333;transition:all .3s;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ncQo0JB1pJEd3mDsmCk7:hover .D08VzPpgn40iEjlhtU7s{color:#000}.ncQo0JB1pJEd3mDsmCk7.YgXjlzm7Pw0COGDTofEH{text-align:right}.XOBwycXUwfIkVzY1pEcS{font-size:14px;line-height:2}.XOBwycXUwfIkVzY1pEcS h1{margin-bottom:20px;font-weight:500;font-size:30px;font-family:Avenir,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji",sans-serif;line-height:38px}.XOBwycXUwfIkVzY1pEcS h1:first-child{margin-top:8px}.XOBwycXUwfIkVzY1pEcS h2{font-size:24px;line-height:32px}.XOBwycXUwfIkVzY1pEcS h2,.XOBwycXUwfIkVzY1pEcS h3,.XOBwycXUwfIkVzY1pEcS h4,.XOBwycXUwfIkVzY1pEcS h5,.XOBwycXUwfIkVzY1pEcS h6{clear:both;margin:1em 0 .3em;font-weight:500;font-family:Avenir,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji",sans-serif}.XOBwycXUwfIkVzY1pEcS h3{font-size:20px;margin-bottom:4px;font-weight:600;line-height:30px;border-bottom:1px solid #f0f0f0}.XOBwycXUwfIkVzY1pEcS h4{font-size:16px;font-weight:600;margin:0}.XOBwycXUwfIkVzY1pEcS h5{font-size:14px}.XOBwycXUwfIkVzY1pEcS h6{font-size:12px}.XOBwycXUwfIkVzY1pEcS hr{clear:both;height:1px;margin:56px 0;background:#f0f0f0;border:0}.XOBwycXUwfIkVzY1pEcS p{line-height:32px}.XOBwycXUwfIkVzY1pEcS p,.XOBwycXUwfIkVzY1pEcS pre{margin:.6em 0}.XOBwycXUwfIkVzY1pEcS pre>code[class*=language-]{line-height:1.8}.XOBwycXUwfIkVzY1pEcS pre[class*=language-]{background-color:#00000008}.XOBwycXUwfIkVzY1pEcS code[class*=language-]{background:none}.XOBwycXUwfIkVzY1pEcS code[class*=language-text]{white-space:break-spaces;word-break:break-word}.XOBwycXUwfIkVzY1pEcS code.waFWvzMZG5InNNS0or0P,.XOBwycXUwfIkVzY1pEcS pre.waFWvzMZG5InNNS0or0P{background:#e6f7ff}.XOBwycXUwfIkVzY1pEcS pre.waFWvzMZG5InNNS0or0P{border:1px solid #91d5ff}.XOBwycXUwfIkVzY1pEcS .gatsby-highlight-code-line{background-color:#f9f0ff;border-left:2px solid #873bf4}.XOBwycXUwfIkVzY1pEcS .iZl0EtcrU8pvn5BU8P4U{opacity:.68}.XOBwycXUwfIkVzY1pEcS ul,.XOBwycXUwfIkVzY1pEcS ol{margin:0;padding:0}.XOBwycXUwfIkVzY1pEcS ul:not(.ant-skeleton-paragraph)>li{margin-left:20px;padding-left:4px;list-style-type:circle}.XOBwycXUwfIkVzY1pEcS ul:not(.ant-skeleton-paragraph)>li:empty{display:none}.XOBwycXUwfIkVzY1pEcS ol>li{margin-left:20px;padding-left:4px;list-style-type:decimal}.XOBwycXUwfIkVzY1pEcS ul>li>p,.XOBwycXUwfIkVzY1pEcS ol>li>p{margin:.2em 0}.XOBwycXUwfIkVzY1pEcS strong,.XOBwycXUwfIkVzY1pEcS b{font-weight:500}.XOBwycXUwfIkVzY1pEcS table{width:100%;margin:24px 0;empty-cells:show;border:1px solid #f0f0f0;border-collapse:collapse;border-spacing:0}.XOBwycXUwfIkVzY1pEcS table img{max-width:100%}.XOBwycXUwfIkVzY1pEcS table th{color:#5c6b77;font-weight:500;background:rgba(0,0,0,.02)}.XOBwycXUwfIkVzY1pEcS table th,.XOBwycXUwfIkVzY1pEcS table td{padding:4px 12px;text-align:left;border:1px solid #f0f0f0;line-height:24px}.XOBwycXUwfIkVzY1pEcS table img{max-height:100px}.XOBwycXUwfIkVzY1pEcS table td:first-child{width:20%;font-weight:500;background:#fcfcfc;color:#000000d9}.XOBwycXUwfIkVzY1pEcS blockquote{margin:.5em 0;padding-left:.8em;color:#00000073;font-size:90%;border-left:4px solid #f0f0f0}.XOBwycXUwfIkVzY1pEcS blockquote p{margin:0}.XOBwycXUwfIkVzY1pEcS>br,.XOBwycXUwfIkVzY1pEcS>p>br{clear:both}.T4GEFebs3g8YOid0x1WP{margin:24px 0 32px}.T4GEFebs3g8YOid0x1WP .ant-layout-content{background-color:#fff}.jvyuEa1IMUYz6QYdQz8J{background-color:#fff;width:calc(100% - 260px);padding-left:48px;padding-right:24px;padding-bottom:24px;overflow:hidden}.jvyuEa1IMUYz6QYdQz8J .tSv9Qb5vksc9XnyKyOKB{margin-bottom:1.2em}.jvyuEa1IMUYz6QYdQz8J ._NVcNxMxDngqGlso_eik{min-height:400px}.jvyuEa1IMUYz6QYdQz8J ._NVcNxMxDngqGlso_eik>img,.jvyuEa1IMUYz6QYdQz8J ._NVcNxMxDngqGlso_eik>p>img{max-width:100%;margin:.5em 0}.jvyuEa1IMUYz6QYdQz8J ._NVcNxMxDngqGlso_eik>br,.jvyuEa1IMUYz6QYdQz8J ._NVcNxMxDngqGlso_eik>p>br{clear:both}.jvyuEa1IMUYz6QYdQz8J ._NVcNxMxDngqGlso_eik>div{min-height:400px}.jvyuEa1IMUYz6QYdQz8J ._NVcNxMxDngqGlso_eik>div>img,.jvyuEa1IMUYz6QYdQz8J ._NVcNxMxDngqGlso_eik>div>p>img{max-width:100%;margin:.5em 0}.jvyuEa1IMUYz6QYdQz8J ._NVcNxMxDngqGlso_eik>div>br,.jvyuEa1IMUYz6QYdQz8J ._NVcNxMxDngqGlso_eik>div>p>br{clear:both}.JRX7qH9aso0S3_49fqvn{width:260px;float:right;font-size:12px;background:#fff;max-height:100vh;overflow:hidden;position:sticky;top:0;padding:8px 0}.JRX7qH9aso0S3_49fqvn ul>li{list-style:none!important;padding:0!important;margin-left:1em!important;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.JRX7qH9aso0S3_49fqvn ul>li a{color:#000000d9}.j_lVBXjD1Zoetgjpd_bN{width:280px!important;height:inherit;background-color:#fff}.j_lVBXjD1Zoetgjpd_bN .ant-layout-sider-children{overflow:hidden}.j_lVBXjD1Zoetgjpd_bN .ant-layout-sider-children:hover{overflow-y:auto}.UtVe7vVYEykNfHBTSp_e{background-color:#fff}.UtVe7vVYEykNfHBTSp_e>div{height:100%}.cRzD_TvGZoAfHovAo4Rh{opacity:.6;font-size:16px!important;position:relative;top:1px;margin-right:8px!important}.xmfECgHVedYAt3TiQg3M .drawer{z-index:9}.xmfECgHVedYAt3TiQg3M .ant-menu{border-right:0}.xmfECgHVedYAt3TiQg3M .mnFzgAhr4_YhXIP2f1J3{position:absolute;top:72px;right:-40px;width:40px;height:40px;cursor:pointer;z-index:0;text-align:center;line-height:40px;font-size:16px;display:flex;justify-content:center;align-items:center;background:#fff;box-shadow:2px 0 8px #00000026;border-radius:0 4px 4px 0}.KynRwLTHLzs40xw0ZsgZ{display:flex;flex-direction:row-reverse}.KynRwLTHLzs40xw0ZsgZ .NixFYMoANcTHWwQeLGLj{flex:1 1}.KynRwLTHLzs40xw0ZsgZ .JGs06hr_HcOpmWTRWsy3{width:260px;padding-left:24px}.KynRwLTHLzs40xw0ZsgZ .JGs06hr_HcOpmWTRWsy3 .ant-anchor{font-size:12px}.KynRwLTHLzs40xw0ZsgZ .JGs06hr_HcOpmWTRWsy3 .ant-anchor-link{padding-top:5px;padding-bottom:5px}.KynRwLTHLzs40xw0ZsgZ .v90vC3gZt54Nwza4KgSs{list-style:none;margin:0 -12px!important}.KynRwLTHLzs40xw0ZsgZ .RmkpYWHI9d4RYQiIr3CY{display:inline-block;vertical-align:top;width:25%;margin:0!important;padding:0!important}.KynRwLTHLzs40xw0ZsgZ .RmkpYWHI9d4RYQiIr3CY .X6AtY7FPSlY8cpJZ7YgY{display:block;position:relative;cursor:pointer;transition:all .3s;margin:12px}.KynRwLTHLzs40xw0ZsgZ .RmkpYWHI9d4RYQiIr3CY .X6AtY7FPSlY8cpJZ7YgY .UoWLG9mnhIsRxu4NYc4v{background-size:contain;background-repeat:no-repeat;background-position:center}.KynRwLTHLzs40xw0ZsgZ .RmkpYWHI9d4RYQiIr3CY .X6AtY7FPSlY8cpJZ7YgY>div{border:1px solid #f0f0f0;border-radius:6px;overflow:hidden;height:calc(100vw / 9 - 20px);min-height:130px;max-height:280px;object-fit:cover;transition:all .3s;display:flex;justify-content:center}.KynRwLTHLzs40xw0ZsgZ .RmkpYWHI9d4RYQiIr3CY .X6AtY7FPSlY8cpJZ7YgY>div img{max-width:100%;max-height:100%;object-fit:scale-down}.KynRwLTHLzs40xw0ZsgZ .RmkpYWHI9d4RYQiIr3CY .X6AtY7FPSlY8cpJZ7YgY:hover>div{transform:translateY(-4px);border-color:transparent;box-shadow:0 6px 16px #6b93e024}.KynRwLTHLzs40xw0ZsgZ .RmkpYWHI9d4RYQiIr3CY .X6AtY7FPSlY8cpJZ7YgY h4{margin:16px 0 0;text-align:center;color:#101424;font-size:16px;line-height:22px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.KynRwLTHLzs40xw0ZsgZ .RmkpYWHI9d4RYQiIr3CY .FWIxiPRIbgg0ov3PIPmJ{transform:rotate(45deg) translate(5px,-12px);border-radius:0;width:65px;height:18px;font-size:14px;font-weight:500;line-height:18px;text-align:center}.KynRwLTHLzs40xw0ZsgZ .RmkpYWHI9d4RYQiIr3CY .FWIxiPRIbgg0ov3PIPmJ .ant-ribbon-corner{display:none}.feSyyZNeX08GT1w4HmAs{padding:0}.PUK1AXn01mkNMld0ATNk{margin-left:.5em;font-size:16px;color:#999;vertical-align:middle;position:relative;top:-2px}.BdbTVaZHv0ATN3BQ27i2{margin-top:-24px}.BdbTVaZHv0ATN3BQ27i2 .SplitPane{overflow:auto;left:0px;height:calc(100vh - 64px)!important}.BdbTVaZHv0ATN3BQ27i2 .Pane2{overflow:auto}.BdbTVaZHv0ATN3BQ27i2 .ant-collapse-extra{margin-left:16px;display:inline-block;float:none!important}@media only screen and (max-width: 1199.99px){.KynRwLTHLzs40xw0ZsgZ .RmkpYWHI9d4RYQiIr3CY{width:33.3%}}@media only screen and (max-width: 991.99px){.XOBwycXUwfIkVzY1pEcS .jvyuEa1IMUYz6QYdQz8J{width:100vw!important;padding-left:32px;padding-right:32px}.XOBwycXUwfIkVzY1pEcS .JRX7qH9aso0S3_49fqvn{display:none}.j_lVBXjD1Zoetgjpd_bN{width:240px!important}.KynRwLTHLzs40xw0ZsgZ .RmkpYWHI9d4RYQiIr3CY{width:50%}.KynRwLTHLzs40xw0ZsgZ .JGs06hr_HcOpmWTRWsy3{display:none}}@media only screen and (max-width: 767.99px){.T4GEFebs3g8YOid0x1WP{flex-direction:column!important}.j_lVBXjD1Zoetgjpd_bN{width:100%!important;margin-bottom:32px;padding-bottom:32px;border-bottom:1px solid #e8e8e8;display:none}.XOBwycXUwfIkVzY1pEcS .jvyuEa1IMUYz6QYdQz8J{margin-top:30px;padding-left:24px;padding-right:24px;margin-bottom:30px}}@media only screen and (max-width: 575.99px){.KynRwLTHLzs40xw0ZsgZ .RmkpYWHI9d4RYQiIr3CY{width:100%}}.mIZjxLtB6g6XFUD2qT8I{overflow-x:hidden;overflow-y:hidden}.mIZjxLtB6g6XFUD2qT8I:hover{overflow-y:auto}.mIZjxLtB6g6XFUD2qT8I .ant-anchor-link{width:100%;height:100%;padding:0;display:flex;align-items:center}.mIZjxLtB6g6XFUD2qT8I .ant-anchor-ink{display:none}.mIZjxLtB6g6XFUD2qT8I .ant-anchor-link-title{width:100%;height:100%;padding:0;display:flex;align-items:center}.EwYNXg2XN0sVAfR4yA_t{padding-left:14px;overflow:hidden}.EwYNXg2XN0sVAfR4yA_t:hover{overflow-y:auto}.EwYNXg2XN0sVAfR4yA_t .ant-anchor-ink-ball{width:2px;height:24px;background-color:#873bf4;border:none;border-radius:0;transform:translate(-50%) translateY(-8px)}.EwYNXg2XN0sVAfR4yA_t .anticon{position:absolute;padding-top:5px;font-size:12px;color:red}.EwYNXg2XN0sVAfR4yA_t .eJcNDVXSXMkgfmCUKIed,.EwYNXg2XN0sVAfR4yA_t .jfvgaW8NaogBNoI9HDGa{padding:5px 0 5px 14px;font-size:12px}.O_LWZof2U8meFcNxprwL{color:#868484;background-color:#fff;box-shadow:0 3px 6px -4px #0000001f,0 6px 16px #00000014,0 9px 28px 8px #0000000d;transition:color .3s;width:44px;height:44px;line-height:44px;font-size:22px;border-radius:50%;text-align:center}
.T4GEFebs3g8YOid0x1WP{
  height: 100%;
}
</style>
